<template>
  <div class="bg-white padding">
    <div class="input-item flex">
      <div style="display: flex" class="text-nowrap">
        <div class="line"></div>
        請輸入車號
      </div>
    </div>
    <div class="form">
      <div class="item">
        <div class="field">車種</div>
        <div class="carType">
          <div :class="getMotorcycleButtonClass" @click.prevent="carType = 'M'" style="margin-right: 8pt">
            <input type="radio" id="motorcycle" name="carType" v-model="carType" value="M" />
            <label for="motorcycle">機車</label>
          </div>
          <div :class="getCarButtonClass" @click.prevent="carType = 'C'" style="margin-left: 8pt">
            <input type="radio" id="car" name="carType" v-model="carType" value="C" />
            <label for="car">汽車</label>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="field">
          車號
          <span class="text-gray2">（範例：ABC-1234 或 1234-ABC）</span>
        </div>
        <div class="cardNumber">
          <input v-model.trim="number0" name="number0" maxlength="4" ref="number0" @focus="inFocus = true" @keyup="changeNumber0" @blur="inFocus = false" />
          <span class="space-line"></span>
          <input v-model.trim="number1" name="number1" maxlength="4" ref="number1" @focus="inFocus = true" @keyup="changeNumber1" @blur="inFocus = false" />
        </div>
        <div class="padding">
          <button class="btn btn-primary" @click="nextStep" :disabled="isDisabled">新增</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'add-car-number',
  data() {
    return {
      carNumber0: '',
      carNumber1: '',
      carType: 'M',
      inFocus: false,
    };
  },
  mounted() {
    //this.$refs.number0.focus();
  },
  activated() {
    //this.$refs.number0.focus();
  },
  methods: {
    ...mapActions(['sentApp']),
    changeNumber0(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number0.length >= 4) {
        this.$refs.number1.focus();
      }
    },
    changeNumber1(e) {
      e.target.value = this.trimLength(e.target.value.replace(/[\W]/g, ''), 4);
      if (this.number1.length >= 4) {
        this.$refs.number1.blur();
      }
    },
    trimLength(string, length) {
      return string.length > length ? 
             string.substring(0, length) :
             string;
    },  
    nextStep() {
      if (this.supportFeatures.supportCardlessBinding) {
        this.sentApp({
          action: 'openParkingPaymentAuthorize',
          payload: { car_type: this.carType, car_number: this.carNumber0 + '-' + this.carNumber1 },
        });
      } else {
        this.$router.push({ path: '/carPark/termsOfPolicy', query: { car_number: this.carNumber0 + '-' + this.carNumber1, car_type: this.carType } });      
      }
    },
  },
  computed: {
    ...mapGetters(['supportFeatures']),
    isDisabled() {
      return this.carNumber0 === '' || this.carNumber1 === '';
    },
    number0: {
      get: function () {
        return this.carNumber0;
      },
      set: function (val) {
        this.carNumber0 = val.toUpperCase().replace(/\s/g, '');
      },
    },
    number1: {
      get: function () {
        return this.carNumber1;
      },
      set: function (val) {
        this.carNumber1 = val.toUpperCase().replace(/\s/g, '');
      },
    },
    getMotorcycleButtonClass() {
      return this.carType === 'M' ? 'radio-group active' : 'radio-group';
    },
    getCarButtonClass() {
      return this.carType === 'C' ? 'radio-group active' : 'radio-group';
    },
  },
};
</script>

<style scoped>
.form .item {
  margin-top: 24pt;
}

.cardNumber {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.cardNumber input {
  background: rgba(64, 64, 64, 0.05);
  border: none;
  font-size: 16px;
  line-height: 30px;
  padding: 11pt 0;
  width: 50%;
  text-align: center;
}

.carType {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.carType .radio-group {
  padding: 11pt 0;
  border: 1px solid rgba(64, 64, 64, 0.1);
  border-radius: 4pt;
  display: flex;
  justify-content: center;
  width: 50%;
  align-items: center;
  -webkit-box-sizing: border-box;
  -webkit-transition: background ease-in 0.1s;
}

.carType .radio-group.active {
  background: #f9b238;
  color: #fff;
  font-size: 16px;
}

.carType .radio-group input[type='radio'] {
  display: none;
}

.space-line {
  margin: 0 8pt;
  background: #000;
  height: 1px;
  content: '';
  display: block;
  width: 20pt;
}
</style>
